/**
 * Service géolocalisation — rafraîchissement silencieux de la « dernière
 * position connue » de l'utilisateur authentifié (PRD §6.1.7).
 *
 * POST /api/v1/geolocation/capture met à jour users.latitude/longitude/
 * geolocation_timestamp/geolocation_source, qui sont lus par tous les
 * consommateurs backend (recherche du Relais le plus proche, distances
 * d'accompagnement, carte admin, fiche de validation gouverneur).
 */

import api from './api.js';

/**
 * Persiste la position GPS de l'utilisateur authentifié (best-effort).
 * Ne throw jamais : les coordonnées hors Sénégal sont rejetées (400) par le
 * backend — cas normal pour la diaspora — et un échec ne doit jamais impacter
 * la session. Ne jamais logger les coordonnées (doctrine PII, LOGGING_SPEC).
 *
 * @param {{ latitude: number, longitude: number, precision_meters?: number|null }} coords
 * @returns {Promise<boolean>} true si la position a été enregistrée
 */
export async function captureMyLocation({ latitude, longitude, precision_meters }) {
  try {
    await api.post('/geolocation/capture', {
      latitude,
      longitude,
      precision: precision_meters ?? null,
      source: 'gps',
    });
    return true;
  } catch {
    return false;
  }
}

/**
 * Plan B (PRD §6.1.7, v4.60.0) : aucun GPS appareil disponible ou permission
 * non accordée — appelé SANS coordonnées, le backend géocode alors l'adresse/
 * localité déclarée par l'utilisateur (source 'geocoded') puis, à défaut,
 * déduit une position approximative depuis l'IP (source 'ip'). Best-effort,
 * ne throw jamais.
 *
 * @returns {Promise<boolean>} true si le serveur a répondu
 */
export async function captureMyLocationFallback() {
  try {
    await api.post('/geolocation/capture', {});
    return true;
  } catch {
    return false;
  }
}
